var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ contain: true, mobile: _vm.isMobile }},[(_vm.isShowLoading)?_c('div',{staticClass:"load py-lg-16 d-flex flex-column"},[_c('img',{attrs:{"src":require("@/assets/loading.gif"),"alt":""}}),_c('h1',{class:{darkFont:this.$vuetify.theme.dark }},[_vm._v(_vm._s(_vm.$t('loadingLoading'))+"...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }